export default __webpack_public_path__ + "media/images/images_v2/bordcell2-445d2ad44fd7db6437adc006507385ab.png";